import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  NEW_COMMON_PRODUCT_PATH,
  COMMON_PRODUCT_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import CommonProductForm from './CommonProductForm';
import { postCommonProduct } from '../../../../actions/cargo';
import Content from '../../../layout/Content';

const NewCommonProduct = ({ breadcrumbs, dispatchPostCommonProduct }) => {
  
  const content = (
    <CommonProductForm onSubmit={dispatchPostCommonProduct} />
  )

  return (
    <Content 
      title="Crear Producto Frecuente"
      subtitle="Crear Producto Frecuente"
      breadcrumbs={breadcrumbs}
      content={content}
    />
  )
}

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Producto Frecuente',
      href: COMMON_PRODUCT_PATH,
    },
    {
      text: 'Nuevo',
      href: NEW_COMMON_PRODUCT_PATH,
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostCommonProduct: postCommonProduct,
};

NewCommonProduct.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostCommonProduct: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewCommonProduct);
